import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import SearchProductCategoryModal from '../../../../views/app/common/modal/SearchProductCategoryModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class SearchProductCategoryModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIdList: [],
    };
  }

  componentDidMount() {
    const { getItemSearchList } = this.props;
    getItemSearchList();
  }

  onClickItem = (idList) => {
    this.setState({
      selectedIdList: idList,
    });
  };

  onSubmit = () => {
    const { selectedIdList } = this.state;
    const { data } = this.props;
    const { productCategoryAllList, setData } = data;

    if (!selectedIdList.length) {
      message.error('상품 카테고리를 최소 1개는 선택하셔야 합니다.');
      return;
    }

    // 1차 카테고리
    const mainProductCategory = productCategoryAllList.find(
      (item) => selectedIdList.includes(item.id) && !item.parentId,
    );

    // 2차 카테고리
    const subProductCategory = productCategoryAllList.filter(
      (item) => selectedIdList.includes(item.id) && item.parentId,
    );

    if (setData) {
      setData({
        mainProductCategory,
        subProductCategory,
      });
    }

    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchProductCategoryModal', value: false });
  };

  render() {
    const { selectedIdList } = this.state;

    return (
      <SearchProductCategoryModal
        {...this.props}
        selectedIdList={selectedIdList}
        onClickItem={this.onClickItem}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.searchProductCategoryModal.isOpen,
    data: state.app.searchProductCategoryModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
  getItemSearchList: appActions.getItemSearchList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchProductCategoryModalContainer));
